import '../assets/title.css';
import { jsx as s } from "react/jsx-runtime";
import l from "clsx";
import { forwardRef as m, useContext as a } from "react";
import { AlertContext as n } from "../context.js";
const c = "_title_u3ota_3", f = {
  title: c
}, p = m(({ children: t, className: e, ...o }, r) => {
  const { severity: i } = a(n);
  return /* @__PURE__ */ s("div", { ref: r, className: l(f.title, e), ...o, "data-severity": i, children: t });
});
p.displayName = "Title";
export {
  p as Title
};
